import accessToken from "../../helpers/accessToken";
import Mixins from "../../mixins/GlobalMixins";
import API_URL from "../../helpers/apiUrls";
import router from '../../router/index'

const state = {
    leadFormJSON : {},
    formList : [],
    formListTotalCount : 0
}

const mutations = {
    SET_FORM_LIST : (state, value) => {
        let formID = '';
        if(router.currentRoute.query.formID)
            formID = router.currentRoute.query.formID;

        state.formList = value.form_list.map((data, index) => {
            if(formID) 
                return {isFormSelected : formID === data.form_id ? true : false, ...data}
            return {isFormSelected : index === 0 ? true : false, ...data}
        });

        state.formListTotalCount = value.total_data;
    },

    APPEND_FORM_LIST : (state, value) => {
        let formID = '';
        if(router.currentRoute.query.formID)
            formID = router.currentRoute.query.formID;

        const newList = value.form_list.map((data) => {
            if(formID) 
                return {isFormSelected : formID === data.form_id ? true : false, ...data}
            return {isFormSelected : false, ...data}
        });

        state.formList = [...state.formList, ...newList]

        state.formListTotalCount = value.total_data;
    },

    SET_LEAD_FORM_GENERATION : (state, value) => {
        state.leadFormJSON = {...state.leadFormJSON, ...value}
    },
}

const actions = {
    getFormList({commit, dispatch}, payload) {
        dispatch('mainStore/toggleLoader', true, {root : true});
        const successHandler = response => {
          if(response.status === 200) {
            dispatch('mainStore/toggleLoader', false, {root : true});
            if(payload.type === 'append')
                commit('APPEND_FORM_LIST', response.data);
            else
                commit('SET_FORM_LIST', response.data);
          }
        }
    
        const errorHandler = error => {
          dispatch('mainStore/toggleLoader', false, {root : true});
          Mixins.methods.showToast('Something went wrong internally!', 'error', 10000);
          console.log(error);
        }
    
        const headers = {
          'Authorization' : `Bearer ${accessToken.getAccessToken()}`,
          //'BRAND-ID' : localStorage.getItem('Brand-ID')
        }
    
        const data = {
          creator_id : localStorage.getItem("Brand-ID"),
          creator_type : 'brand',
          page : payload.page,
          data_per_page : payload.perPage
        }
    
        Mixins.methods.requestGET(
          API_URL.createContent_leadFormList,
          data,
          headers,
          successHandler,
          errorHandler
        )
    },

    getFormConfigs({dispatch}, data) {
        const successHandler = response => {
            if(response.status === 200) {
                dispatch('setLeadFormJSON', response.data.form_creation_info);
            }
        }

        const errorHandler = error => {
            Mixins.methods.showToast('Something went wrong internally!', 'error', 10000);
            console.log(error);
        }

        const headers = {
            'Authorization' : `Bearer ${accessToken.getAccessToken()}`,
            //'BRAND-ID' : localStorage.getItem('Brand-ID')
        }

        Mixins.methods.requestGET(
            API_URL.createContent__formConfigs,
            data,
            headers,
            successHandler,
            errorHandler
        )
    },

    setLeadFormJSON({commit}, data) {
        commit('SET_LEAD_FORM_GENERATION', data);
    },
}

const getters = {
    GET_LEAD_FORM_JSON : (state) => {
        return state.leadFormJSON
    },

    GET_LEAD_FORM_CONFIGS : state => {
        return state.leadFormJSON.form_inputs_config
    },

    GET_FORM_LIST : (state) => state.formList,

    GET_FORM_TOTAL_COUNT : (state) => state.formListTotalCount
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};